import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/appThemes.css";
import "@/styles/festiveThemes.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initBranding } from "@/config/branding";
import { initTheme } from "@/config/theme";

initBranding();
initTheme();

// Suppress PostHog/third-party analytics errors that don't affect app functionality
const originalConsoleError = console.error;
console.error = (...args) => {
  const errorString = String(args[0] || '');
  if (errorString.includes('postMessage') || 
      errorString.includes('PerformanceServerTiming') ||
      errorString.includes('posthog') ||
      errorString.includes('DataCloneError')) {
    return; // Suppress PostHog errors
  }
  originalConsoleError.apply(console, args);
};

// "ResizeObserver loop ..." ialah amaran pelayar yang tidak berbahaya (dicetuskan oleh
// carta/dialog semasa saiz berubah). Hentikan sebelum ia sampai ke overlay ralat dev.
const isResizeObserverNoise = (msg) => /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i.test(String(msg || ''));
window.addEventListener('error', (event) => {
  if (isResizeObserverNoise(event.message) || isResizeObserverNoise(event.error?.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  }
}, true);

// Global error handler for uncaught errors from third-party scripts
window.addEventListener('error', (event) => {
  const errorMsg = String(event.message || '');
  const filename = String(event.filename || '');
  if (errorMsg.includes('postMessage') || 
      errorMsg.includes('PerformanceServerTiming') ||
      errorMsg.includes('DataCloneError') ||
      filename.includes('posthog')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const reasonMsg = String(event.reason?.message || event.reason || '');
  if (reasonMsg.includes('postMessage') || 
      reasonMsg.includes('PerformanceServerTiming') ||
      reasonMsg.includes('DataCloneError')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}, true);

// Suppress React error overlay for PostHog errors
if (typeof window !== 'undefined') {
  const originalOnerror = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    const msgStr = String(message || '');
    const srcStr = String(source || '');
    if (msgStr.includes('postMessage') || 
        msgStr.includes('PerformanceServerTiming') ||
        msgStr.includes('DataCloneError') ||
        srcStr.includes('posthog')) {
      return true; // Prevents the error from being shown
    }
    if (originalOnerror) {
      return originalOnerror(message, source, lineno, colno, error);
    }
    return false;
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA Auto-Update
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // New content is available - notify via service worker message
    console.log('[PWA] New version available!');
    
    // Automatically activate the new service worker
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    
    // Banner is now handled by AppUpdateNotification.js React component
    // This provides better UX with dismiss functionality and version display
  },
  onSuccess: (registration) => {
    console.log('[PWA] App is now cached for offline use.');
  }
});
